/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function openWaitlistPopup(productInfo, trigger) {
    if (!productInfo) return;

    var notificationButton = productInfo.querySelector('[data-notification-popup]');
    var variantInput = productInfo.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    var variantId = variantInput && variantInput.value;
    var handle = productInfo.dataset.productHandle;

    if (notificationButton) {
      notificationButton.disabled = false;
      notificationButton.removeAttribute('disabled');

      if (handle) notificationButton.setAttribute('data-handle', handle);
      if (variantId) notificationButton.setAttribute('data-variant-id', variantId);

      notificationButton.click();
      return;
    }

    if (!handle || !variantId || !window.theme || !window.theme.LoadPhotoswipe) return;

    var root = window.theme.routes && window.theme.routes.root ? window.theme.routes.root : '/';
    var url = root + 'products/' + handle + '?section_id=api-notification&variant=' + variantId;
    var options = {
      history: false,
      focus: false,
      mainClass: 'pswp--notification pswp--not-close-btn',
      closeOnVerticalDrag: false
    };

    fetch(url)
      .then(function(response) {
        return response.text();
      })
      .then(function(html) {
        new window.theme.LoadPhotoswipe([{ html: html }], options, 1, trigger || null);
      })
      .catch(function(error) {
        console.log('error: ', error);
      });
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-waitlist-option-trigger], [data-waitlist-button-trigger]');

    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    openWaitlistPopup(trigger.closest('product-info'), trigger);
  });






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
